export default {
    methods: {
        openUrl(url, checkProtocol = false, newTab = true, errorMessage = '') {
            if (checkProtocol && !(/^https?:\/\//i.test(url)))
                url = `https://${url}`;

            let win = window.open(url, newTab ? '_blank' : '_self');

            if (!win || win.closed || typeof win.closed === 'undefined') {
                if (errorMessage)
                    this.$toast.error(errorMessage, this.$t('toast.blockedPopup'), { position: 'topRight' });
                else
                    this.$toast.error(this.$t('toast.blockedPopup'), '', { position: 'topRight' });
            }
            else {
                win.focus();
            }
        },

        openRelativeUrl(relativeUrl, newTab) {
            if (newTab)
                this.openUrl(`${window.location.origin}${relativeUrl}`, false, true);
            else
                this.$router.push(relativeUrl);
        }
    }
};
